import { createSlice } from "@reduxjs/toolkit";
import { getFindYourQuestionById, updateFindYourQuestionById, deleteFindYourQuestion,createFindYourQuestion,getAllFindYourQuestions } from "../../API/FormsData/FindYourQuestions";

const initialState = {
    getallFindYourQuestions: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
};

const findYourQuestionsSlice = createSlice({
  name: "FindYourQuestions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFindYourQuestionById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFindYourQuestionById.fulfilled, (state, action) => {
        state.loading = false;
        state.getallFindYourQuestions = [action.payload]; // Flat FindYourQuestions object array
        state.error = null;
      })
      .addCase(getFindYourQuestionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateFindYourQuestionById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateFindYourQuestionById.fulfilled, (state, action) => {
        state.loading = false;
        state.updateFindYourQuestion = [action.payload]; // Flat FindYourQuestions object array
        state.error = null;
      })
      .addCase(updateFindYourQuestionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteFindYourQuestion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFindYourQuestion.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteFindYourQuestion = [action.payload]; // Flat FindYourQuestions object array
        state.error = null;
      })
      .addCase(deleteFindYourQuestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllFindYourQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllFindYourQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.getallFindYourQuestions = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(getAllFindYourQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createFindYourQuestion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createFindYourQuestion.fulfilled, (state, action) => {
        state.loading = false;
        state.createFindYourQuestion = [action.payload]; // Flat FindYourQuestions object array
        state.error = null;
      })
      .addCase(createFindYourQuestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default findYourQuestionsSlice.reducer;